import { Component, OnInit, ChangeDetectionStrategy, OnDestroy } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { CascadeLagDeviceDetails, InstallationDetailsStore } from '@store';
import { Observable, Subject } from 'rxjs';
import { map, takeUntil } from 'rxjs/operators';
import { LagDeviceModel } from 'src/app/@store/cascades/lag-device.model';
import { InstallationService } from '../services/installation.service';

@Component({
  selector: 'app-installation-limited',
  templateUrl: './installation-limited.component.html',
  styleUrls: ['./installation-limited.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class InstallationLimitedComponent implements OnInit, OnDestroy {
  installationId: number;
  gatewaySerial: string;
  data: {
    header: string;
    tiles: {
      label: string;
      value: string;
    }[];
  }[];

  isCascadeInstallation: boolean;
  lagDevices$: Observable<LagDeviceModel[]>;
  lagDevicesImageUri: string;

  ngUnsubscribe$: Subject<void> = new Subject<void>();

  constructor(
    public installationDetailsStore: InstallationDetailsStore,
    private activatedRoute: ActivatedRoute,
    private installationService: InstallationService,
    private router: Router
  ) {}

  ngOnInit(): void {
    this.activatedRoute.queryParams.subscribe((queryParams) => {
      this.gatewaySerial = queryParams?.gatewaySerial;
    });

    this.activatedRoute.params.subscribe((param) => {
      this.installationId = +param?.id;
      this.getData();
    });

    this.data = Array(6).fill({
      header: this.randomStringValue(),
      tiles: Array(4)
        .fill({})
        .map(() => ({ label: this.randomStringValue(), value: this.randomStringValue() })),
    });

    this.lagDevices$ = this.installationDetailsStore.getSequencedCascadeLagDevices$.pipe(
      takeUntil(this.ngUnsubscribe$),
      map((lagDeviceDetails: CascadeLagDeviceDetails[]) =>
        lagDeviceDetails?.map((lagDevice) => ({
          ...lagDevice,
          imageUri: this.lagDevicesImageUri,
        }))
      )
    );
  }

  getData(): void {
    const id = this.installationId;

    if (Number.isInteger(+id)) {
      this.installationService.setInstallationId(id);
      this.installationDetailsStore.readInstallationDetails(id);
    } else {
      this.router.navigate(['/installations']);
    }
  }

  randomStringValue(): string {
    let string = '';
    const characters = 'AEIOUaeiou ';
    let counter = 0;
    const length = Math.floor(Math.random() * 16 + 3);
    while (counter < length) {
      string += characters.charAt(Math.floor(Math.random() * characters.length));
      counter += 1;
    }

    return string;
  }

  ngOnDestroy(): void {
    this.ngUnsubscribe$.next();
    this.ngUnsubscribe$.complete();
  }
}
